import React from 'react';

const RelocationPrefIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_26649_125413)">
      <path
        d="M15 6.66797C15 10.418 10 14.168 10 14.168C10 14.168 5 10.418 5 6.66797C5 5.34189 5.52678 4.07012 6.46447 3.13243C7.40215 2.19475 8.67392 1.66797 10 1.66797C11.3261 1.66797 12.5979 2.19475 13.5355 3.13243C14.4732 4.07012 15 5.34189 15 6.66797Z"
        stroke="#616893"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9987 8.33333C10.9192 8.33333 11.6654 7.58714 11.6654 6.66667C11.6654 5.74619 10.9192 5 9.9987 5C9.07822 5 8.33203 5.74619 8.33203 6.66667C8.33203 7.58714 9.07822 8.33333 9.9987 8.33333Z"
        stroke="#616893"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3638 11.668H4.16797C3.99841 11.6772 3.83573 11.738 3.70169 11.8423C3.56765 11.9465 3.46866 12.0892 3.41797 12.2513L1.7513 17.2513C1.66797 17.3346 1.66797 17.418 1.66797 17.5013C1.66797 18.0013 2.0013 18.3346 2.5013 18.3346H17.5013C18.0013 18.3346 18.3346 18.0013 18.3346 17.5013C18.3346 17.418 18.3346 17.3346 18.2513 17.2513L16.5846 12.2513C16.5339 12.0892 16.435 11.9465 16.3009 11.8423C16.1669 11.738 16.0042 11.6772 15.8346 11.668H12.6388"
        stroke="#616893"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_26649_125413">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default RelocationPrefIcon;
